<template>
    <b-overlay :show="loading">
        <b-row class="justify-content-center">
            <b-col sm="12" md="11">
                <b-card title="Rekap Dropping & Retail">
                    <form-filter-export @onExport="print" :type_export="['excel', 'pdf']">
                        <template #default>
                            <b-form-group v-if="!isSales" label="Sales" class="mr-2 mb-0" style="min-width: 260px;">
                                <v-select
                                    :options="salesOptions"
                                    v-model="dataExport.sales_id"
                                    label="text"
                                    :reduce="option => option.value"
                                    placeholder="Semua Sales"
                                    :clearable="false"
                                />
                            </b-form-group>
                        </template>
                    </form-filter-export>
                </b-card>
            </b-col>
        </b-row>
    </b-overlay>
</template>
<script>
import FormFilterExport from '@core/components/form-filter-export/FormFilterExport.vue'
import {BOverlay, BRow, BCol, BCard, BFormGroup} from 'bootstrap-vue'
import vSelect from 'vue-select'
import mixin from './mixin'
export default {
    mixins: [mixin],
    components: {
        FormFilterExport,
        vSelect,
        BOverlay, BRow, BCol, BCard, BFormGroup
    },
    data: () => ({
        dataExport: {
            sales_id: null,
        },
        salesOptions: [],
        loading: false,
    }),
    methods: {
        parseFilename(disposition, fallback) {
            if (!disposition) return fallback
            const utfMatch = disposition.match(/filename\*=UTF-8''([^;]+)/i)
            if (utfMatch && utfMatch[1]) {
                try {
                    return decodeURIComponent(utfMatch[1])
                } catch (e) {
                    return utfMatch[1]
                }
            }
            const match = disposition.match(/filename="?([^";]+)"?/i)
            return match && match[1] ? match[1] : fallback
        },
        openBlob(blob, filename, type_export) {
            const url = URL.createObjectURL(blob)
            if (type_export === 'excel') {
                const link = document.createElement('a')
                link.href = url
                link.download = filename
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                setTimeout(() => URL.revokeObjectURL(url), 1000)
                return
            }
            window.open(url)
            setTimeout(() => URL.revokeObjectURL(url), 60000)
        },
        async print({tgl_awal, tgl_akhir, type_export}) {
            if(!tgl_awal || !tgl_akhir) {
                this.displayError({
                    message: 'Harap isi tanggal awal dan akhir!'
                })
                return false
            }

            const params = {
                tgl_awal,
                tgl_akhir,
                type_export
            }
            if (this.isSales && this.user && this.user.karyawan) {
                params.sales_id = this.user.karyawan.id
            } else if (this.dataExport.sales_id) {
                params.sales_id = this.dataExport.sales_id
            }

            try {
                this.loading = true
                const response = await this.printLaporan(params)
                this.loading = false
                const fallback = type_export === 'pdf'
                    ? 'Rekap Dropping & Retail.pdf'
                    : 'Rekap Dropping & Retail.xlsx'
                const filename = this.parseFilename(
                    response.headers && (response.headers['content-disposition'] || response.headers['Content-Disposition']),
                    fallback
                )
                this.openBlob(response.data, filename, type_export)
            }
            catch(e) {
                console.error(e)
                this.loading = false
                this.displayError(e)
                return false
            }
        },
        async getSales() {
            const levels = await this.$store.dispatch('level/getData', {
                search: 'sales'
            })
            const salesLevel = levels.find(level => this.getShortName(level.nama_level) == 'sales')
            const params = {}
            if(salesLevel) params.level_id = salesLevel.id

            const sales = await this.$store.dispatch('pengguna/getData', params)
            this.salesOptions = [
                { value: null, text: 'Semua Sales' },
                ...sales.map(item => ({
                    value: item.karyawan.id,
                    text: item.karyawan.nama_lengkap
                }))
            ]
            this.dataExport.sales_id = null
        },
    },
    created() {
        if (!this.isSales) {
            this.getSales()
        }
    }
}
</script>
